import ApiError from '@/features/api/error'
import { AddressSuggestion, GeoApi as GeoApiType, ValidatedAddress } from '@/features/api/geo/types'
import axios, { AxiosError } from 'axios'

class GeoApi implements GeoApiType {
    private readonly axiosInstance = axios.create({
        baseURL: process.env.EXPO_PUBLIC_GEO_API_BASE_URL,
        headers: { Authorization: process.env.EXPO_PUBLIC_GEO_API_AUTH_TOKEN },
    })

    getAddressSuggestions = async (address: string, country: string, filters: string[]) => {
        try {
            const { data } = await this.axiosInstance.get<{ suggestions: AddressSuggestion[] }>(
                'suggestions',
                { params: { q: address, country, filters } }
            )

            return data.suggestions
        } catch (e) {
            const error = e as AxiosError

            throw new ApiError(error, error.status)
        }
    }

    validateAddress = async (address: string, country: string) => {
        try {
            const { data } = await this.axiosInstance.post<{ address: ValidatedAddress }>(
                '/validations',
                {},
                { params: { address, country } }
            )

            return data.address
        } catch (e) {
            const error = e as AxiosError

            throw new ApiError(error, error.status)
        }
    }
}

export const geoApi = new GeoApi()
